import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import ConditionalTooltipWrapper from "../helpers/components/ConditionalTooltipWrapper";
import { EMPTY_OBJ } from "../helpers/logic/empties";
import Typography from "../Typography";
import ChipCheckbox from "./components/Checkbox";
import ChipIcon from "./components/ChipIcon";
import MetaLabel from "./components/MetaLabel";
import RemoveButton from "./components/RemoveButton";
import { BaseChip, BaseChipLabelContainer } from "./styled";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function Chip(_ref) {
  var label = _ref.label,
    metaLabelProps = _ref.metaLabelProps,
    iconProps = _ref.iconProps,
    chipCheckboxProps = _ref.chipCheckboxProps,
    removeButtonProps = _ref.removeButtonProps,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "default" : _ref$size,
    onClick = _ref.onClick,
    tooltipContent = _ref.tooltipContent,
    isDisabled = _ref.isDisabled,
    _ref$overflowBehavior = _ref.overflowBehavior,
    overflowBehavior = _ref$overflowBehavior === void 0 ? "wrap" : _ref$overflowBehavior;
  var _ref2 = removeButtonProps || EMPTY_OBJ,
    onRemoveClick = _ref2.onClick;
  var handleRemove = function handleRemove(e) {
    e.preventDefault();
    e.stopPropagation();
    onRemoveClick(e);
  };
  return /*#__PURE__*/_jsx(ConditionalTooltipWrapper, {
    tooltipContent: tooltipContent,
    children: /*#__PURE__*/_jsxs(BaseChip, {
      size: size,
      isInteractive: Boolean(onClick) && !isDisabled,
      onClick: !isDisabled && onClick,
      includeRightPadding: !onRemoveClick,
      reduceLeftPadding: Boolean(iconProps),
      isDisabled: isDisabled,
      children: [/*#__PURE__*/_jsx(ChipIcon, _extends({}, iconProps)), /*#__PURE__*/_jsxs(BaseChipLabelContainer, {
        overflowBehavior: overflowBehavior,
        children: [/*#__PURE__*/_jsx(Typography, {
          color: "inherit",
          variant: "body",
          htmlTag: "span",
          children: label
        }), metaLabelProps && /*#__PURE__*/_jsx(MetaLabel, _extends({}, metaLabelProps))]
      }), chipCheckboxProps && /*#__PURE__*/_jsx(ChipCheckbox, _extends({}, chipCheckboxProps)), removeButtonProps && /*#__PURE__*/_jsx(RemoveButton, _extends({}, removeButtonProps, {
        onClick: handleRemove,
        isDisabled: isDisabled
      }))]
    })
  });
}
export default Chip;